/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { isNotNil } from 'es-toolkit';

import i18n from '@fai/friendli-suite/features/i18n';
import { DedicatedDatasetStatus } from '@fai/friendli-suite/generated/client/graphql';
import type { Nullish } from '@fai/util/types';

export const datasetStatusOptions = [
  {
    label: i18n.t('dedicated_endpoints.project.dataset_status_uploading'),
    value: DedicatedDatasetStatus.Uploading,
  },
  {
    label: i18n.t('dedicated_endpoints.project.dataset_status_validating'),
    value: DedicatedDatasetStatus.Validating,
  },
  {
    label: i18n.t('dedicated_endpoints.project.dataset_status_ready'),
    value: DedicatedDatasetStatus.Created,
  },
  {
    label: i18n.t('dedicated_endpoints.project.dataset_status_failed'),
    value: DedicatedDatasetStatus.Failed,
  },
  {
    label: i18n.t('dedicated_endpoints.project.dataset_status_deleted'),
    value: DedicatedDatasetStatus.Deleted,
  },
];

export const isDatasetFinetuneable = (status: Nullish<DedicatedDatasetStatus>) => {
  return (
    isNotNil(status) &&
    [
      DedicatedDatasetStatus.Created, // TODO: confirm this
    ].includes(status)
  );
};

export const isDatasetDeleteable = (status: Nullish<DedicatedDatasetStatus>) => {
  return (
    isNotNil(status) &&
    [
      DedicatedDatasetStatus.Created, // TODO: confirm this
    ].includes(status)
  );
};

export const shouldDatasetStatusBePolled = (status: Nullish<DedicatedDatasetStatus>) => {
  return (
    isNotNil(status) &&
    [
      DedicatedDatasetStatus.Uploading,
      DedicatedDatasetStatus.Validating,
      DedicatedDatasetStatus.Created, // TODO: confirm this
    ].includes(status)
  );
};
